import { render, staticRenderFns } from "./BaseDonut.vue?vue&type=template&id=42cd5da4&"
import script from "./BaseDonut.vue?vue&type=script&lang=js&"
export * from "./BaseDonut.vue?vue&type=script&lang=js&"
import style0 from "./BaseDonut.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports